module.exports = __webpack_public_path__ + "static/media/app-screen-2.45bd4958.png";